module.exports = __webpack_public_path__ + "static/media/Fernando.0943d150.jpg";